module.exports = __webpack_public_path__ + "static/img/jobs_img3.5656b84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jobs_img3.png
// module id = Bg+T
// module chunks = 94